import { useMemo, useReducer } from 'react';
import type { FunctionComponent, ReactNode } from 'react';

import SeedProductsContext from './SeedProductsContext';
import { getActions } from './actions';
import { initialState, reducer } from './reducer';
import * as selectors from './selectors';

const SeedProductsProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useMemo(() => getActions(dispatch), [dispatch]);

  return (
    <SeedProductsContext.Provider value={{ actions, selectors, state }}>
      {children}
    </SeedProductsContext.Provider>
  );
};

export default SeedProductsProvider;
